import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NuqsAdapter } from "nuqs/adapters/react-router/v6";

import { AuthProvider } from "./providers/Auth";

import config from "./config/config";
import { IntercomProvider } from "react-use-intercom";
import { RouterProvider } from "./providers/Routes";
import { ErrorBoundary } from "providers/ErrorBoundary";
import { ProgressProvider } from "providers/ProgressContext";
import { Slide, ToastContainer } from "react-toastify";
import { PostHogProvider } from "posthog-js/react";
import "react-toastify/dist/ReactToastify.css";
import { ChatProvider } from "providers/Chat";
import { MediaQueryProvider } from "shared/providers";
import { DatadogProvider } from "providers/DatadogProvider";
import { NotificationProvider } from "./providers/NotificationProvider";

import "react-data-grid/lib/styles.css";

const INTERCOM_APP_ID = config.intercomId!;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false
    }
  }
});

const options = {
  api_host: config.posthog.host
};

function App() {
  return (
    <>
      <DatadogProvider />

      <ErrorBoundary>
        <IntercomProvider appId={INTERCOM_APP_ID}>
          <PostHogProvider apiKey={config.posthog.key} options={options}>
            <QueryClientProvider client={queryClient}>
              <AuthProvider>
                <ProgressProvider>
                  <ChatProvider>
                    <MediaQueryProvider>
                      <NotificationProvider>
                        <NuqsAdapter>
                          <RouterProvider />
                        </NuqsAdapter>
                      </NotificationProvider>
                    </MediaQueryProvider>
                  </ChatProvider>
                </ProgressProvider>
              </AuthProvider>
            </QueryClientProvider>
          </PostHogProvider>
          <ToastContainer
            limit={3}
            style={{
              padding: "16px",
              borderRadius: "8px",
              fontSize: "14px"
            }}
            transition={Slide}
            className="toast-container no-print"
            hideProgressBar
            closeButton={false}
            closeOnClick
            position="bottom-center"
            autoClose={2500}
            theme="colored"
          />
        </IntercomProvider>
      </ErrorBoundary>
    </>
  );
}

export default App;
